export const enum APP_MSG {

	SELECT_NEXT_ITEM = 'Now select another item from the menu to attach it to the %1',
	CANNOT_PLACE_ITEM = 'There is nowhere to put the %1',
	PLACE_THE_ITEM = 'Click a %2 to place the %1',
	ITEM_ACTIVE = 'Click the X to delete, or a %2 to place the %1',

}

export const enum SERIES_ID {

	SERENDIPITY = 2,
	PLAYAROUND = 3,
	RESIDENTIAL_INDOOR = 4,
	FROLIC = 7,
	RESIDENTIAL_PLAYROOM = 10,
	OUTDOOR_PLAYHOUSE = 12,
	COMMERCIAL_2ANDOVER = 13,
	COMMERCIAL_OUTDOOR = 14,
	COMMERCIAL_PLAYROOM = 15,
	COMMERCIAL_INDOOR_UNDER2 = 17,
	RUSTIC = 18,
	CLASSIC = 19,
	ARCHITECTURAL = 20,
	COMMERCIAL_OUTDOOR_UNDER2 = 21

}

export const enum LIBRARY_KEY {

	RUSTIC = 'R',
	CLASSIC = 'C',
	ARCHITECTURAL = 'A',
	ORIGINAL = 'O',
	MIRROR = 'M',
	PLAIN = 'P',
	CUTOUT = 'U',
	COLOR = 'C'

}

export const SERIES_NAMES: {} = {

	14: 'Commercial Outdoor',
	7: 'Frolic',
	2: 'Serendipity',
	13: 'Commercial 2&Over',
	4: 'Residential Indoor',
	17: 'Commercial Indoor Under2',
	18: 'Rustic',
	19: 'Classic',
	20: 'Architectural',
	21: 'Commercial Outdoor Under2'

}

export const enum INDOOR_OUTDOOR {

	INDOOR = 1,
	OUTDOOR = 2

}

export const enum ACCOUNT_TYPE {

	GUEST = 1,
	ACCOUNT = 2

}

export const enum ITEM_ROLE {

	ITEM = 1,
	ATTACHABLE = 2,
	PARENT = 3

}

export const enum ITEM_NAME {

	FENCE = 'Fence',

}

export const enum APP_LEVEL {

	GROUND = 0,
	DECK = 1

}

export const enum YN {

	NO = 0,
	YES = 1

}

export const enum CONST {

	CATALOG = 'catalog'
}

export const enum FREEBIRD_URL {

	DEV = 'http://designdev.cedarnet.local/popup',
	OFFICE = 'http://designer.cedarnet.local/popup',
	WWW = 'https://designer.cedarworks.com/popup',
	HOME = 'http://designer.zone.x/popup'

}

export const enum THREE_D_URL {

	DEV = 'http://3dev.cedarnet.local',
	OFFICE = 'http://3d.cedarnet.local',
	WWW = 'https://3d.cedarworks.com',
	HOME = 'http://3d.zone.x'

}

export const enum APP_LOCATION {

	OFFICE = 'office',
	WWW = 'www'

}

export const enum APP_ROLE {

	DESIGN = 'design',
	PREVIEW = 'preview',
	THUMB = 'thumb',
	LIBRARY = 'library'

}

export const enum APP_USE {

	DESIGN = 'design',
	VIEW = 'view'

}

export const enum APP_STATE {

	ACTIVE = 1,
	INACTIVE = 2

}

export const enum APP_EVT {

	ROTATE_DESIGN = 1,
	FLIP_DESIGN = 2,
	MOVE_DESIGN = 3,
	SHOW_SAVE_MODAL = 4,
	SAVE_CHECK = 5,
	SAVE_DESIGN = 6,
	SAVE_SUCCESS = 7,
	RETRIEVE_USER_DESIGN = 8,
	RETRIEVE_DESIGN = 9,
	SHOW_RETRIEVE_MODAL = 10,
	SHOW_DESIGN_LIST_MODAL = 11,
	LIST_SUCCESS = 12,
	RETRIEVE_DESIGN_BY_ID = 13,
	ACTIVATE_LEVEL = 14,
	SUBMIT_QUOTE_REQUEST = 15,
	TOGGLE_ACTIVE_LEVEL = 16,
	SHOW_CATALOG_SETS = 17,
	TOGGLE_ROOF_PANEL = 18,
	ROOF_ROTATE = 19,
	TOGGLE_DEBUG_PANEL = 20,
	TOGGLE_DEBUG_CLICKCLIP = 21,
	TOGGLE_DEBUG_DIMENSIONS = 22,
	TOGGLE_DEBUG_YBOX = 23,
	PRINT_DESIGN = 24,
	TOGGLE_EDIT_OPTIONS = 26,
	TOGGLE_MENU = 27,
	ITEM_OPTION_CHANGE = 28,
	KEY_DOWN_ENTER = 29,
	SCALE_DESIGN = 30,
	RETRIEVE_SUCCESS = 32,
	FLASH_SUCCESS = 33,
	FLASH_ERROR = 34,
	ROOF_SET_STYLE = 35,
	APP_READY = 36,
	CLICKCLIP_MOUSE_OVER = 37,
	CLICKCLIP_MOUSE_UP = 38,
	CLICKCLIP_MOUSE_OUT = 39,
	ITEM_PLACED = 40,
	SET_INACTIVE = 41,
	SHOW_BOX = 42,
	HIDE_BOX = 43,
	HITPOINT_ROLLOVER = 44,
	SHOW_ITEM_OPTIONS = 45,
	ITEM_ROTATED = 47,
	ROOF_MOUSE_UP = 48,
	OPTION_ICON_MOUSE_OVER = 49,
	OPTION_ICON_MOUSE_UP = 50,
	OPTION_ICON_MOUSE_OUT = 51,
	TMP_CHILD_MOUSE_UP = 52,
	DISABLE_INTRO = 53,
	GET_DIMENSIONS = 54,
	MENU_ITEM_BUTTON_CLICK = 55,
	ITEM_ACTIVE = 56,
	DELETE_ALL = 57,
	RETRIEVE_CATALOG_SET = 58,
	DELETE_ITEM = 59,
	VIEW_3D = 60,
	ITEM_OPTION_CHANGED = 61,
	TOGGLE_ROOF_SVG = 62,
	TOGGLE_TOOL_PANEL = 63,
	TOGGLE_BAY_LABELS = 64,
	BAYLABEL_ROLLOVER = 65,
	SHOW_QUOTE_REQUEST_MODAL = 66,
	RETRIEVE_DESIGN_LIST = 67,
	MENU_ITEM_MOUSE_OVER = 68,
	MENU_ITEM_MOUSE_OUT = 69,
	STAGE_MOUSE_UP = 70,
	DESIGN_CHANGED = 71,
	DEACTIVATE_ITEM = 72,
	TOGGLE_DEBUG_XBOX = 73,
	SHOW_XBOX = 74,
	HIDE_XBOX = 75,
	TOGGLE_SERIES = 76,
	TOGGLE_FLOOR_PANEL = 77,
	ACTIVATE_OPTION_MODE = 78,
	OPTION_ITEM_ACTIVE = 79,
	FLOOR_SET_STYLE = 80,
	ENABLE_ITEMS = 81,
	DEACTIVATE_OPTION_MODE = 82,
	TOGGLE_DEBUG_TBOX = 83,
	HIDE_OPTION_STATES = 85,
	TOGGLE_FENCE_PANEL = 86,
	SHOW_ELEVATION_HITPOINTS = 87,
	HIDE_ELEVATION_HITPOINTS = 88,
	FENCE_BAY_MOUSE_OVER = 89,
	FENCE_BAY_MOUSE_OUT = 90,
	FENCE_BAY_MOUSE_UP = 91,
	FENCE_CLIP_MOUSE_UP = 92,
	FENCE_OPTION_MOUSE_OVER = 93,
	FENCE_OPTION_MOUSE_OUT = 94,
	FENCE_OPTION_BUTTON_CLICK = 95,
	FENCE_BAY_OVER = 96,
	FENCE_BAY_OUT = 97,
	FENCE_BAY_CLICK = 98,
	FENCE_OPTIONS_PANEL_MOUSE_OVER = 99,
	FENCE_OPTIONS_PANEL_MOUSE_OUT = 100,
	SET_FENCE_OPTION = 101,
	SORT_ITEMS = 102,
	ELEVATION_ITEM_BUTTON_CLICK = 103,
	PLAYHOUSE_PANEL_MOUSE_UP = 104,
	PLAYHOUSE_PANEL_MOUSE_OUT = 105,
	TOGGLE_ELEVATION_PANEL = 106,
	SHOW_FENCE_HITPOINTS = 107,
	HIDE_FENCE_HITPOINTS = 108,
	PLAYHOUSE_PANEL_ITEM_DELETE = 109,
	SET_PLAYHOUSE_COLOR = 110,
	ROOF_COLOR_SET = 111,
	ROOF_SET_CUPOLA = 112,
	UPDATE_PACKLIST = 113,
	TOGGLE_NOTES = 114,
	SHOW_DELETE_ICON = 115,
	FENCE_HIDE_OPTIONS = 116,
	TOGGLE_DECK_PANEL = 117,
	SET_DECK_LEVEL = 118,
	HIDE_LINE_OPTION_STATES = 119,
	TOGGLE_EXTRA_HEADROOM = 120,
	SET_DEPENDENCIES = 121,
	TOGGLE_DEBUG_SBOX = 122,
	TOGGLE_DEBUG_POSTS = 123,
	CALCULATE_POSTS = 124,
	TOGGLE_CODES = 125,
	CLICKCLIP_MOUSE_DOWN = 126,
	PLAYHOUSE_PANEL_ERROR = 127,
	SET_DECK_LABEL = 128,
	DISPLAY_ERROR_POPUP = 129,
	SET_HEADROOM = 130,
	ACCOUNT_LOGIN = 131,
	TOGGLE_EXTENDER_COLOR = 132,
	SHOW_ROOFS = 133,
	HIDE_ROOFS = 134,
	OBSCURE_ITEMS = 135,
	SET_EXTENDER_COLOR = 136,
	SET_GTAG = 137,
	AUTH_MODAL_CLOSED = 138,
	PLACE_AUTO_ITEM = 139,
	RETRIEVE_MULTI_SUCCESS = 140,
	SHOW_LIBRARY_LIST_MODAL = 141,
	RETRIEVE_LIBRARY_LIST = 142,
	LIBRARY_LIST_SUCCESS = 144,
	SAVE_FLIPPED_DESIGN = 145,
	POST_FLIP_ADJUSTMENTS = 146,
	CHANGE_FENCES_TO_PLAIN = 148,
	CHANGE_FENCES_TO_CUTOUT = 149,
	INIT_SAVE_LIBRARY_DESIGN = 150,
	SAVE_LIBRARY_DESIGN = 151,
	SAVE_LIBRARY_VARIATIONS = 152,
	RETRIEVE_LIBRARY_SET = 153,
	SHOW_LIBRARY_OPENER = 154,
	RETRIEVE_LIBRARY_CODES = 155,
	LIBRARY_CODE_LIST_SUCCESS = 156,
	TOGGLE_SHOW_FENCES = 157,
	SHOW_FENCES = 158,
	STAGE_DRAG_START = 159,
	SHOW_SHARE_3D_MODAL = 160,
	SHARE_3D_SUCCESS = 161,
	TEST_ROOFS = 162

}


export const enum AGE_RANGE {

	R0205 = '2 to 5 years',
	R0212 = '2 to 12 years',
	R0512 = '5 to 12 years',
	R0623 = '6 to 23 months'

}

export const enum PLAQUE_CODE {

	PL_212 = 'PLAQUE212',
	PL_25 = 'PLAQUE25',
	PL_512 = 'PLAQUE512',
	PL_623 = 'PLAQUE623',
	PL_WARN = 'PLAQUEWARN',

}
export const enum BG_COLOR {

	DEFAULT = '#FDFDFD',
	ROOFS = '#E3F3FD',
	FLOOR = '#D4DBB3'

}

export const enum DESIGN_MODE {

	DEFAULT = 'design',
	LIBRARY = 'library'

}

export const enum LABEL_FONT_COLOR {

	BLACK = '#000000',
	BLUE = '#3d7ca2',
	BROWN = '#88576d',

}

export const enum CUPOLA_STYLE_ID {

	NONE = 0,
	STARS = 1,
	PLANK = 2

}

export const enum USER_INTEREST {

	RESIDENTIAL = 'residential',
	COMMERCIAL = 'commercial'

}


export const enum ITEM_TYPE {

	STRUCTURE = 'structure',
	CONNECTOR = 'connector',
	PLAYHOUSE = 'playhouse',
	BALCONY = 'balcony',
	DRAGGABLE = 'draggable',
	ROOF = 'roof',
	YARDARM = 'yardarm',
	BRIDGE = 'bridge',
	MONKEYBAR = 'monkeybar',
	FENCE = 'fence'

}


export const enum OPTION_TYPE {

	ROOF_STYLE = 1,
	FLOOR_STYLE = 2,
	OPTIONS = 3,
	DECKS = 4,
	LEVELS = 5,
	ITEM_HEIGHT = 6,
	FENCES = 7,
	ELEVATIONS = 8,
	TRIM_COLOR = 9,
	CUPOLA_STYLE = 10,
	ROOF_COLOR = 11,
	ROOF_FLAG_STYLE = 12,
	ROOF_ROTATION = 13,
	DECK_ROTATION = 14,
	EXTRA_HEADROOM = 15,
	ROOF_SCOOPS = 16
}
